import { types, flow, getSnapshot } from 'mobx-state-tree';
import { navigate } from 'js/services/Network';
import { pick } from 'lodash';

import { makeRequest, url, errorResponse } from 'js/services/Network';
import { castEventToValue } from 'js/services/FormTools';
import analytics from 'js/services/Analytics';
import AnonymousId from 'js/services/AnonymousId';

import SteppedPage from 'js/stores/SteppedPage';
import Address from '../types/Address';
import AppState from "js/stores/AppState";

const UploadItemsPageState = types
  .model('UploadItemsPage', {
    isSubmitting: false,
    isUploading: false,
    modalIsVisible: false,
    error: types.maybeNull(types.string),
    anonymous_id: AnonymousId,

    isHoveringFiles: false,
    isUploadingFiles: false,
    uploadFilesError: '',
    items: types.array(types.frozen()),
    successConfirmation: false,
    uploadSuccessed: false,

    selectedFile: '',

    primary_image: '',
    title: '',
    price: '',
    size: '',
    address: types.optional(Address, {}),
  })
  .actions(self => {
    return {
      getStepRoute(step) {
        return url('upload-items-page', {
          step,
        });
      },

      initStep(step) {
        self.modalIsVisible = false;
        return self;
      },

      load: flow(function* load() {
        const response = yield makeRequest('upload-items-data', self);
        self.address = response.data.address || {};
        self.title = new URLSearchParams(window.location.search).get('title') || '';
        self.hasEnteredTitle = self.title.length > 0;
      }),

      uploadFile: flow(function* uploadFile(file) {
        self.isUploadingFiles = true;
        self.uploadFilesError = '';
        try {
          const response = yield makeRequest('upload-items-file', null, file);
          self.primary_image = response.data.primary_image;
          self.isUploadingFiles = false;
          self.items = response.data.items;
          self.uploadFilesError = '';
        } catch (error) {
          self.uploadFilesError = errorResponse(error);
          self.isUploadingFiles = false;
        }
      }),

      submit: flow(function* submit() {
        let response;
        if (!self.isSubmitting) {
          self.isSubmitting = true;
          self.error = null;

          try {
            response = yield makeRequest(
              'upload-items',
              null,
              pick(self, ['title', 'price', 'size', 'address', 'anonymous_id']),
            );

            const alias = response.data.alias;

            analytics
              .track('Multiple items uploaded', {
                'Event Initiated by': 'seller'
              });

            navigate(url('status-page', { alias }));
          } catch (error) {
            self.error = errorResponse(error);
          }

          self.isSubmitting = false;
        }
        return response;
      }),

      setError(message) {
        self.error = message;
        return self;
      },
      onUpload(image_url) {
        self.primary_image = image_url;
      },
      openModal() {
        self.modalIsVisible = true;
        return self;
      },
      closeModal() {
        self.modalIsVisible = false;
        return self;
      },

      nextDetail() {
        if (!self.hasEnteredTitle && self.title) {
          self.hasEnteredTitle = true;
        } else if (!self.hasEnteredPrice && self.price && parseInt(self.price) > 0) {
          self.hasEnteredPrice = true;
        } else {
          self.nextStep();
        }
      },
      setTitle(title) {
        self.title = castEventToValue(title);
      },
      setPrice(price) {
        self.price = castEventToValue(price);
      },
      setSize(size) {
        self.size = castEventToValue(size);
        return self;
      },
      addressSaved(savedAddress) {
        self.address.setAddress(getSnapshot(savedAddress));
        self.modalIsVisible = false;
      },
      setSelectedFile(file) {
        self.selectedFile = file;
      },
      setSuccessConfirmation(success) {
        self.successConfirmation = success;
      },
      setSuccessUpload(status) {
        self.uploadSuccessed = status
      }
    };
  });

export default types.compose(
  SteppedPage,
  UploadItemsPageState,
);
